<template>
  <div class="projectDetail">
    <b-card
      :title="getProjectName"
      :img-src="getImage(project)"
      img-top
      @click="toggleImageSize"
      :class="{ isSmallImage }"
    >
    </b-card>
    <iframe
      width="725"
      height="408"
      :src="project.youtube"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      v-if="project.youtube"
    ></iframe>
    <b-card
      title=""
      :img-src="project.circuit"
      img-top
      class="circuitCard"
      v-if="project.circuit"
    >
    </b-card>
  </div>
</template>

<script>
import util from '@/libs/util'
import { mapState } from 'vuex'

export default {
  name: 'ProjectDetail',
  props: ['project'],
  data() {
    return {
      isSmallImage: true
    }
  },
  computed: {
    ...mapState(['devices', 'filteredTabs', 'language']),
    getProjectName() {
      return util.getProjectName(this.project, this.language)
    }
  },
  methods: {
    async toggleImageSize() {
      this.isSmallImage = !this.isSmallImage
    },
    getImage(project) {
      const tab = _.find(this.filteredTabs, { type: _.get(project, 'tab') })
      const device = _.find(this.devices, { type: _.get(tab, 'type') })
      return project.image
        ? project.image
        : device
        ? device.imageUrl
        : undefined
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 1199px) {
  .projectDetail .card + iframe {
    margin-top: 30px;
  }
}
</style>

<style>
.projectDetail {
  display: inline-block;
}

.projectDetail .card {
  max-width: 100%;
  display: inline-block;
}

.projectDetail .card:first-of-type {
  cursor: pointer;
}

.projectDetail .card.isSmallImage {
  width: 330px;
  margin-right: 13px;
}

.projectDetail .card:not(.isSmallImage) {
  display: block;
}

.projectDetail .card-body {
  height: 80px;
}

.projectDetail .card-title {
  font-size: 18px;
  line-height: 26px;
}

.projectDetail .card + iframe {
  max-width: 100%;
  vertical-align: top;
  display: inline-block;
}

.projectDetail .card:not(.isSmallImage) + iframe {
  margin-top: 30px;
}

.projectDetail .card.circuitCard {
  margin-top: 13px;
  border: none;
}

.projectDetail .card.circuitCard .card-body {
  height: 0;
  padding: 0;
}
</style>
